import React from 'react';

const AddDoctor = () => {
    return (
        <div>
            <h1>This is Add a Doctor Page</h1>
        </div>
    );
};

export default AddDoctor;